<template>
    <div>
        <!-- <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar> -->
        <Header :drawer="$store.state.drawer"></Header>
        <Sidebar :drawer="$store.state.drawer"></Sidebar>
        <v-content>
            <!-- <v-container>
                <v-card>
                    <v-card-title class="justify-center" style="margin-top: 80px;">VUNET Result</v-card-title>
                    <v-card-text>
                        
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th>
                                        Application Number
                                    </th>
                                    <th>
                                        Application Date
                                    </th>
                                    <th>
                                        Program/Course
                                    </th>
                                    <th>
                                        Exam Date
                                    </th>
                                    <th>
                                        Exam Fees
                                    </th>
                                    <th>
                                        Exam Result
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in vunet_applications" :key="index">
                                    <td>{{item.application_number}}</td>
                                    <td>{{item.application_date}}</td>
                                    <td>{{item.program}}</td>
                                    <td>{{item.examdate}}</td>
                                    <td>{{item.examfees}}</td>
                                    <td>
   
                                       
                                         <v-btn @click="onButtonClick(item)">Result</v-btn>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        
                    </v-card-text>
                </v-card>
            </v-container> -->
            <v-container class="main-right">
                <v-card-title>Score Card</v-card-title>
                <!-- style="background-color:#e8e8e8!important" -->
                <!-- {{lapplication}} -->
                <v-row >
                    <v-col cols="12" sm="4" md="4" v-for="(item,index) in vunet_applications" :key="index">
                        <v-card class="card-payess">
                            <div class="card-head-title">Application Number</div>
                            <div class="card-head12">{{item.application_number}}</div>
                            <div class="card-head-title pt-3">Programme Name</div>
                            <div class="card-head12 pgm-no">{{item.program}}</div>
                            <v-row >
                                <v-col cols="12" sm="12" md="12">
                                    <div class="card-head-title pt-3">Application Date</div>
                                    <div class="card-head121">{{item.application_date}}</div>
                                </v-col>
                                
                            </v-row>
                            <row>
                                 <v-col cols="12" sm="12" md="12" class="ml-n3">
                                      <div class="card-head-title pt-3">Exam Date</div>
                                    <div class="card-head121">{{item.examdate}}</div>
                                
                                 </v-col>

                            </row>
                            <v-row class="margin-top:-10px !important;">
                                <v-col cols="12" sm="6" md="6">
                                    <div class="card-head-title">Exam Fees</div>
                                    <div class="card-head12" style="color: #15c322;">{{item.examfees}}</div>
                                </v-col>
                                
                            </v-row>
                            
                            <v-row class="margin-top:0px !important;">
                                <v-col cols="12" sm="6" md="6">
                                  
                                    <div  class="card-head12">
                                        
                                          <v-btn color="#F05A2B" dark @click="onButtonClick(item)" title="View/Download Result" > View Result</v-btn>
                                    </div>
                                   
                                </v-col>

                                
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-content>
    </div>
</template>
<script>
    import axios from "axios";
    import Header from "../shared/Header";
    import Sidebar from "../shared/Sidebar";
    export default {
        components: {
            Header: Header,
            Sidebar: Sidebar,
        },
        data: (vm) => ({
            snackbar_msg: "",
            snackbar: false,
            color: "",
            vunet_applications:null,
             headers: [
          { text: 'Application Number', value: "application_number" },
          { text: 'Program/Course', value: 'program' },
          { text: 'Application Date', value: 'application_date' },
          { text: 'Exam Date', value: 'examdate' },
          { text: 'Result', value: 'result' },
        ],
        }),
        mounted() {
            
            axios
                .post("/Student/vunetExamResult")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.vunet_applications = res.data.vunet_applications
                    }
                })
                .catch((error) => {
                    // this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => {
                    // this.overlay = false;
                });
        },
        methods:{
                    onButtonClick(item) {
            this.$router.push({path:'/student/vunet-exams-result-details',query:{item:item}});
            },
            // showResult(item){
            //     const formdata={
            //         applicatin: item.application_id
            //     }
            //     axios
            //     .post("/Student/showVunetExamResult",formdata)
            //     .then((res) => {
            //         if (res.data.msg == "200") {
                        
            //         }
            //     })
            //     .catch((error) => {
            //         // this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            //     })
            //     .finally(() => {
            //         // this.overlay = false;
            //     });
            // }
        }
    };
</script>
<style scoped>
.pgm-no{
     width: 15em; /* the element needs a fixed width (in px, em, %, etc) */
  overflow: hidden; /* make sure it hides the content that overflows */
  white-space: nowrap; /* don't break the line */
  text-overflow: ellipsis; /* give the beautiful '...' effect */
cursor: pointer;
}
.pgm-no:hover{
    overflow: visible; 
    white-space: normal; 
    cursor: pointer;
}
   .card-head12 {
        text-align: left;
        font: normal normal medium 18px/22px Roboto !important;
        letter-spacing: 0px;
        font-size: 18px;
        color: #212529;
        font-weight: 500;
    }
     .card-head121 {
        text-align: left;
        font: normal normal medium 18px/22px Roboto !important;
        letter-spacing: 0px;
        font-size: 18px;
        color: #212529;
        font-weight: 500;
    }
    .card-head-title {
        text-align: left;
        font-size: 12px;
        font: normal normal medium 12px/14px Roboto !important;
        letter-spacing: 0px;
        color: #212529;
        font-weight: 500;
    }
    .card-payess {
        background: #ffffff 0% 0% no-repeat padding-box;
        box-shadow: 0px 3px 6px #00000029;
        border: 1px solid #c4c4c4;
        padding: 2rem 2rem 2rem 2rem;
    }
</style>
